import { render, staticRenderFns } from "./app.vue?vue&type=template&id=f81d84e0&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81d84e0')) {
      api.createRecord('f81d84e0', component.options)
    } else {
      api.reload('f81d84e0', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=f81d84e0&", function () {
      api.rerender('f81d84e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/app.vue"
export default component.exports